// extracted by mini-css-extract-plugin
export default {"testBox":"fSizqkJaaQuVnPqPJ8OV","resultBox":"eRqChOdpBeMoqgES92BH","resultRow":"vlJcfEV5lalx7As_EOHp"};